import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
const ProtectedRoleRoute = ({ allowedRoles = [], userRole, fallbackComponent }) => !userRole || !allowedRoles.includes(userRole) ? fallbackComponent : _jsx(Outlet, {});
export default ProtectedRoleRoute;
//# sourceMappingURL=index.js.map